module.exports = __webpack_public_path__ + "img/deadpool.fbf669e9.svg";